export enum Templates {
  INDEX = '/templates',
  ARCHIVE = '/templates/archive',
}
